import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';

const GITHUB_PAGES_HOST = 'gantabi.github.io';
const GITHUB_REPO_PATH = '/jrs-forms-web';

function getI18nPrefix(): string {
  if (typeof window !== 'undefined' && window.location.hostname === GITHUB_PAGES_HOST) {
    // Producción en GitHub Pages → forzamos ruta absoluta con carpeta del repo
    // Resultado final: https://gantabi.github.io/jrs-forms-web/assets/i18n/en.json
    return `${GITHUB_REPO_PATH}/assets/i18n/`;
  }

  // Localhost y cualquier otro servidor “normal”
  // Resultado local: http://localhost:4200/assets/i18n/en.json
  return '/assets/i18n/';
}
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

// Interceptor de autenticación para añadir token JWT a las peticiones
import { authInterceptor } from '@core/interceptors/auth.interceptor';

// Interceptor de loading para mostrar spinner automáticamente
import { loadingInterceptor } from '@core/interceptors/loading.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    // Gestión global de errores en el navegador
    provideBrowserGlobalErrorListeners(),

    // Optimización de detección de cambios
    provideZoneChangeDetection({ eventCoalescing: true }),

    // Rutas principales de la aplicación
    provideRouter(routes, withHashLocation()),

    // HttpClient con interceptores de autenticación y loading
    provideHttpClient(withInterceptors([authInterceptor, loadingInterceptor])),

    // Configuración del servicio de traducción
    provideTranslateService({
      // Cargamos los ficheros JSON desde public/assets/i18n
      loader: provideTranslateHttpLoader({
        prefix: getI18nPrefix(),
        suffix: '.json',
      }),
      // Idioma por defecto
      lang: 'en',
      // Idioma de respaldo si falta alguna clave
      fallbackLang: 'en',
    }),
  ],
};
